import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { LL } from 'i18n/i18n.service';

@Component({
  selector: 'cs-coach-banner',
  templateUrl: 'cs-coach-banner.html',
  host: { 'class': 'coach-banner' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsCoachBannerComponent implements AfterViewInit, OnDestroy {
  protected LL = LL;
  @Input() clientDisplayName: string;
  /** Shows a green/grey dot next to the client name. Omit (or pass undefined) to hide the dot entirely. */
  @Input() clientOnline: boolean | undefined;
  @Output() backToMyAccount = new EventEmitter<void>();

  private resizeObserver: ResizeObserver;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.updateBannerHeightVar();
    this.resizeObserver = new ResizeObserver(() => this.updateBannerHeightVar());
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    document.documentElement.style.removeProperty('--coach-banner-height');
  }

  private updateBannerHeightVar() {
    const height = this.elementRef.nativeElement.offsetHeight;
    document.documentElement.style.setProperty('--coach-banner-height', `${height}px`);
  }
}
